export const OSM_STATUS = {
  APPROVED: 1,
  REJECTED: 2,
  NO_RESPONSE: 0
}
